import React from "react";
import BaseDndItem from "./BaseDndItem";

const DndItem = (props) => {
  return <BaseDndItem {...props} type='schedule' scheduleLabel='Schedule No' />;
};

export default DndItem;
